import Api from "../config/Axios";

export const getListingService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/un-register/rider/list`, {params:data, ...config});
};


export const getSingleService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/un-register/rider/detail/`+data, {...config});
};

